<template>
  <div>
    <!-- Email 설정 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3 mr-r15">E-mail 설정</div>
      <div>
        <el-button type="primary" size="small" :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @click="onExecuteAlarmTest('EMAIL')">전송테스트</el-button>
        <el-button type="primary" size="small" :disabled="!changeFlagForEmail" @click="onSaveButton('email')">저장</el-button>
        <el-button size="small" :disabled="!changeFlagForEmail" @click="onCancelButton('email')">취소</el-button>
      </div>
    </el-row>
    <el-row class="mr-b30" :gutter="20">
      <el-col :span="12">
        <div class="list form-list">
          <el-form :model="emailSettingData" ref="emailSettingDataLeftForm" label-width="200px" label-position="left" :show-message="false">
            <el-form-item label="전송 허용 여부">
              <el-switch @change="checkChangeFlag('email')" v-model="emailSettingData.ALARM_APPLY_EMAIL"></el-switch>
            </el-form-item>
            <el-form-item label="SMTP 서버주소" prop="MAILSENDER_SMTP_HOST" :rules="{ trigger: 'blur', validator: this.validatorForHostAddress }">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @change="checkChangeFlag('email')" v-model="emailSettingData.MAILSENDER_SMTP_HOST"></el-input>
            </el-form-item>
            <el-form-item label="SMTP 서버 포트 번호">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" v-model="emailSettingData.MAILSENDER_SMTP_PORT" @change="onChangePort"></el-input>
            </el-form-item>
            <el-form-item label="송신자 대표메일 주소" prop="MAILSENDER_ADDR" :rules="{ trigger: 'blur', validator: this.validatorForEmail }">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @change="checkChangeFlag('email')" v-model="emailSettingData.MAILSENDER_ADDR"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="list form-list">
          <el-form :model="emailSettingData" ref="emailSettingDataRightForm" label-width="200px" label-position="left">
            <el-form-item label="메일계정 ID">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @change="checkChangeFlag('email')" v-model="emailSettingData.MAILSENDER_SMTP_USER"></el-input>
            </el-form-item>
            <el-form-item label="메일계정 비밀번호">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @change="checkChangeFlag('email')" type="password" placeholder="*******" v-model="emailSettingData.MAILSENDER_SMTP_PASSWD"></el-input>
            </el-form-item>
            <el-form-item label="메일 인코딩 타입">
              <el-input :disabled="!emailSettingData.ALARM_APPLY_EMAIL" @change="checkChangeFlag('email')" v-model="emailSettingData.MAILSENDER_ENCODING"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <!-- 문자 메시지 설정 -->
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3 mr-r15">문자 메시지 설정</div>
      <div>
        <el-button type="primary" size="small" :disabled="!smsSettingData.ALARM_APPLY_SMS" @click="onExecuteAlarmTest('SMS')">전송테스트</el-button>
        <el-button type="primary" size="small" :disabled="!changeFlagForSms" @click="onSaveButton('sms')">저장</el-button>
        <el-button size="small" :disabled="!changeFlagForSms" @click="onCancelButton('sms')">취소</el-button>
      </div>
    </el-row>
    <el-row class="mr-b30" :gutter="20">
      <el-col :span="12">
        <div class="list form-list">
          <el-form :model="emailSettingData" ref="smsSettingDataLeftForm" label-width="200px" label-position="left">
            <el-form-item label="전송 허용 여부">
              <el-switch @change="checkChangeFlag('sms')" v-model="smsSettingData.ALARM_APPLY_SMS"></el-switch>
            </el-form-item>
            <el-form-item label="알람전송결과 LOG 저장">
              <el-switch :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_DEBUG_LOG"></el-switch>
            </el-form-item>
            <el-form-item label="전송방식">
              <el-select :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_TYPE">
                <el-option v-for="item in smsSendTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="전송자명">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_NAME"></el-input>
            </el-form-item>
            <el-form-item label="전송자 전화번호">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_TEL_NO"></el-input>
            </el-form-item>
            <el-form-item label="전송 DB 종류">
              <el-select :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="onSmsSenderDbTypeChange" v-model="smsSettingData.SMS_SENDER_DB_TYPE">
                <el-option v-for="item in dbTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="전송 DB 드라이버명">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_DB_DRIVERCLASSNAME"></el-input>
            </el-form-item>
            <el-form-item label="전송 DB 주소">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_DB_URL"></el-input>
            </el-form-item>
            <el-form-item label="대량 발생 방지 허용 여부">
              <el-switch @change="checkChangeFlag('sms')" :disabled="!smsSettingData.ALARM_APPLY_SMS" v-model="smsSettingData.SMS_LOCK_FUNCTION" />
            </el-form-item>
            <el-form-item label="대량 발생 방지 기준 횟수">
              <el-input-number :min="1" @change="checkChangeFlag('sms')" :disabled="!smsSettingData.ALARM_APPLY_SMS || !smsSettingData.SMS_LOCK_FUNCTION" v-model="smsSettingData.SMS_LOCK_COUNT_LIMIT" controls-position="right" />
            </el-form-item>
            <el-form-item label="대량 발생 방지 시준 시간 (초)">
              <el-input-number :min="1" @change="checkChangeFlag('sms')" :disabled="!smsSettingData.ALARM_APPLY_SMS || !smsSettingData.SMS_LOCK_FUNCTION" v-model="smsSettingData.SMS_ALARM_COUNT_CYCLE" controls-position="right" />
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="list form-list">
          <el-form :model="emailSettingData" ref="smsSettingDataRightForm" label-width="200px" label-position="left">
            <el-form-item label="전송 DB 접속 아이디">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_SENDER_DB_USERNAME"></el-input>
            </el-form-item>
            <el-form-item label="전송 DB 접속 패스워드">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" type="password" placeholder="*******" v-model="smsSettingData.SMS_SENDER_DB_PASSWORD"></el-input>
            </el-form-item>
            <el-form-item label="전송 인코딩 타입">
              <el-select :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_ENCODING">
                <el-option v-for="item in dbCharsetList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="DB 테이블 명">
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" v-model="smsSettingData.SMS_TABLE_NAME"></el-input>
            </el-form-item>
            <el-form-item label="DB Table Field 정의">
              <span slot="label">
                <span>DB Table Field 정의</span>
              </span>
              <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" type="textarea" v-model="smsSettingData.SMS_FIELD_NAME" :rows="2"></el-input>
              <el-button style="margin-top:4px;" :disabled="!smsSettingData.ALARM_APPLY_SMS" size="mini" @click="onClickTableDefault('field')">기본 설정 적용</el-button>
            </el-form-item>
            <el-form-item label="DB Table Insert Value" label-width="140px">
              <span slot="label">
                <span>DB Table Insert Value</span>
                <el-popover placement="left" trigger="click" width="600" :offset="40">
                  <w-table-value-legend />
                  <span slot="reference"><i class="fas fa-info-circle c-pointer mr-l4"></i></span>
                </el-popover>
              </span>
              <div>
                <el-input :disabled="!smsSettingData.ALARM_APPLY_SMS" @change="checkChangeFlag('sms')" type="textarea" v-model="smsSettingData.SMS_FIELD_VALUE" :rows="2"></el-input>
                <el-button style="margin-top:4px;" :disabled="!smsSettingData.ALARM_APPLY_SMS" size="mini" @click="onClickTableDefault('value')">기본 설정 적용</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3 mr-r15">알람 클라이언트 전송 설정</div>
      <div>
        <el-button type="primary" size="small" :disabled="!alarmClientSettingData.ALARM_APPLY_MESSENGER" @click="onExecuteAlarmTest('ALARMCLIENT')">전송테스트</el-button>
        <el-button type="primary" size="small" :disabled="!changeFlagForMessenger" @click="onSaveButton('messenger')">저장</el-button>
        <el-button size="small" :disabled="!changeFlagForMessenger" @click="onCancelButton('messenger')">취소</el-button>
      </div>
    </el-row>
    <div class="list form-list">
      <el-form :model="emailSettingData" ref="alarmClientSettingDataForm" label-width="200px" label-position="left">
        <el-form-item label="전송 허용 여부">
          <el-switch @change="checkChangeFlag('messenger')" v-model="alarmClientSettingData.ALARM_APPLY_MESSENGER"></el-switch>
        </el-form-item>
      </el-form>
    </div> -->
  </div>
</template>

<script>
import { cloneDeep, forEach, transform, isEqual, isObject, isNil, assign } from 'lodash';
import { matcher } from '@/utils/string';
import msgUtil from '@/utils/message';
import { PASSWORD_FOR_VIEW } from '@/constants/common';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import WTableValueLegend from './components/TableValueLegend';

export default {
  name: 'WAlarmForSetting',
  components: {
    WTableValueLegend,
  },
  data() {
    return {
      emailSettingData: {},
      smsSettingData: {},
      alarmClientSettingData: {},
      emailSettingDataOrigin: {},
      smsSettingDataOrigin: {},
      alarmClientSettingDataOrigin: {},
      smsSendTypeList: [],
      dbTypeList: [],
      dbCharsetList: [],
      changeFlagForEmail: false,
      changeFlagForSms: false,
      changeFlagForMessenger: false,
    };
  },
  mounted() {
    // 정송방식 axios 호출
    basicinfoSubAPI.getList('SMSSENDTYPE').then((response) => {
      this.smsSendTypeList = response.data.data;
    });
    // 전송 DB 종류 axios 호출
    basicinfoSubAPI.getList('DBTYPE').then((response) => {
      this.dbTypeList = response.data.data;
    });
    // 전승 인코딩 타입 axios 호출
    basicinfoSubAPI.getList('DBCHARSET').then((response) => {
      this.dbCharsetList = response.data.data;
    });
    this.loadData();
  },
  methods: {
    loadData() {
      basicinfoSetAPI.getList('ALARMCONFIG').then((response) => {
        if (response.data.success) {
          this.setAlarmSettingDatas(response.data.data);
          this.emailSettingDataOrigin = cloneDeep(this.emailSettingData);
          this.smsSettingDataOrigin = cloneDeep(this.smsSettingData);
          this.alarmClientSettingDataOrigin = cloneDeep(this.alarmClientSettingData);

          // 변경 플래그 초기화
          this.changeFlagForEmail = false;
          this.changeFlagForSms = false;
          this.changeFlagForMessenger = false;

          this.clearAllValidate();
        }
      });
    },
    // 조회한 basicinfo_set 데이터에서 필요한 값만 꺼내오고 해당하는 form에 매핑한다.
    setAlarmSettingDatas(targetList) {
      const emailSettingData = {};
      const smsSettingData = {};
      const alarmClientSettingData = {};

      forEach(targetList, (item) => {
        let targetValue = '';
        if (item.datatypeId === 'BOOL') {
          if (item.basicinfoSubvalueBoolean === '0') {
            targetValue = false;
          } else {
            targetValue = true;
          }
        } else if (item.datatypeId === 'INTEGER') {
          targetValue = item.basicinfoSubvalueInteger;
        } else if (item.datatypeId === 'STRING') {
          targetValue = item.basicinfoSubvalueString;
        }
        const targetKey = item.basicinfoSubid;
        if (targetKey.indexOf('MAILSENDER') > -1 || targetKey.indexOf('ALARM_APPLY_EMAIL') > -1) {
          emailSettingData[targetKey] = targetValue;
          // this.$set(this.emailSettingData, targetKey, targetValue);
        } else if (targetKey.indexOf('ALARM_APPLY_MESSENGER') > -1) {
          alarmClientSettingData[targetKey] = targetValue;
          // this.$set(this.alarmClientSettingData, targetKey, targetValue);
        } else {
          smsSettingData[targetKey] = targetValue;
          // this.$set(this.smsSettingData, targetKey, targetValue);
        }
      });

      emailSettingData.MAILSENDER_SMTP_PASSWD = PASSWORD_FOR_VIEW;
      smsSettingData.SMS_SENDER_DB_PASSWORD = PASSWORD_FOR_VIEW;

      this.emailSettingData = emailSettingData;
      this.smsSettingData = smsSettingData;
      this.alarmClientData = alarmClientSettingData;
    },
    // 취소 버튼 클릭
    onCancelButton(item) {
      if (item === 'email') {
        this.emailSettingData = cloneDeep(this.emailSettingDataOrigin);
      } else if (item === 'sms') {
        this.smsSettingData = cloneDeep(this.smsSettingDataOrigin);
      } else {
        this.alarmClientSettingData = cloneDeep(this.alarmClientSettingDataOrigin);
      }
      this.checkChangeFlag(item);
    },
    // 저장 버튼 클릭
    // differernce를 통해 origin 데이터와 다른 데이터들을 찾고, 플래그가 false일경우는 플래그 값만 전달하도록 한다.
    onSaveButton(item) {
      let targetData = {};
      let target;
      if (item === 'email') {
        target = 'E-mail';
        if (this.emailSettingData.ALARM_APPLY_EMAIL === false) {
          targetData = {
            ALARM_APPLY_EMAIL: false,
          };
        } else {
          targetData = this.difference(this.emailSettingData, this.emailSettingDataOrigin);
        }
      } else if (item === 'sms') {
        target = '문자 메시지';
        if (this.smsSettingData.ALARM_APPLY_SMS === false) {
          targetData = {
            ALARM_APPLY_SMS: false,
          };
        } else {
          targetData = this.difference(this.smsSettingData, this.smsSettingDataOrigin);
        }
      }
      // else if (item === 'messenger') {
      //   target = '알람 클라이언트';
      //   if (this.alarmClientSettingData.ALARM_APPLY_MESSENGER === false) {
      //     targetData = {
      //       ALARM_APPLY_MESSENGER: false,
      //     };
      //   } else {
      //     targetData = this.difference(this.alarmClientSettingData, this.alarmClientSettingDataOrigin);
      //   }
      // }
      // 저장 api 호출

      const encryptTargetData = createEncryptTargetData(targetData, ['MAILSENDER_SMTP_PASSWD', 'SMS_SENDER_DB_PASSWORD']);
      if (encryptTargetData !== null) {
        getRsaEncrypt(encryptTargetData)
          .then((encryptData) => {
            const params = {
              alarmconfig: assign(targetData, encryptData),
            };
            this.updateAlarmConfigData(params, target);
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(forEach, target, false));
            throw new Error(e);
          });
      } else {
        const params = {
          alarmconfig: targetData,
        };
        this.updateAlarmConfigData(params, target);
      }
    },
    /**
     * 알람 설정을 수정한다.
     * @author Ju
     * @param  {[type]} params [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    updateAlarmConfigData(params, target) {
      const action = msgUtil.action.SAVE;
      OperationSettingsAPI.updateAlarmConfigData(params)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // 두개의 Object를 비교하여 기준과 값이 다른 대상들을 포함하는 새로운 Object변수를 생성하는 함수
    difference(object, base) {
      return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
          result[key] = isObject(value) && isObject(base[key]) ? this.difference(value, base[key]) : value;
        }
      });
    },
    onChangePort(value) {
      this.emailSettingData.MAILSENDER_SMTP_PORT = Number(value);
      this.checkChangeFlag('email');
    },
    // 기본 버튼 클릭 이벤트
    onClickTableDefault(item) {
      if (item === 'field') {
        // 단문 메시지 - 테이블 필드 검색
        OperationSettingsAPI.getDefaultTableField().then((response) => {
          this.smsSettingData.SMS_FIELD_NAME = response.data.data;
          this.checkChangeFlag('sms');
        });
      } else {
        // 단문 메시지 - 테이블 벨류 검색
        OperationSettingsAPI.getDefaultTableValue().then((response) => {
          this.smsSettingData.SMS_FIELD_VALUE = response.data.data;
          this.checkChangeFlag('sms');
        });
      }
    },
    // 범례 슬라이딩 팝업 제공
    onLegendSlidingPop() {
      this.$refs.tableValueLegendSlidingPopup.open();
    },
    // 알람 전송 테스트
    onExecuteAlarmTest(item) {
      const param = {
        param: item,
      };
      let target;
      if (item === 'EMAIL') {
        target = 'E-mail를';
      } else if (item === 'SMS') {
        target = '문자 메시지를';
      } else {
        target = '알람을';
      }
      OperationSettingsAPI.executeAlarmTest(param)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getCustomResultMsgData(`테스트용 ${target} 전송하였습니다.`, true));
          } else {
            this.$message(msgUtil.getCustomResultMsgData(`테스트용 ${target} 전송하지 못하였습니다.`, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getCustomResultMsgData(`테스트용 ${target} 전송하지 못하였습니다.`, false));
        });
    },
    checkChangeFlag(item) {
      if (item === 'email') {
        this.onChangeCheckUserPw(this.emailSettingData, 'MAILSENDER_SMTP_PASSWD');
        this.changeFlagForEmail = !isEqual(this.emailSettingData, this.emailSettingDataOrigin);
      } else if (item === 'messenger') {
        this.changeFlagForMessenger = !isEqual(this.alarmClientSettingData, this.alarmClientSettingDataOrigin);
      } else if (item === 'sms') {
        this.onChangeCheckUserPw(this.smsSettingData, 'SMS_SENDER_DB_PASSWORD');
        this.changeFlagForSms = !isEqual(this.smsSettingData, this.smsSettingDataOrigin);
      }
    },
    onChangeCheckUserPw(row, target) {
      // PW는 사용자가 입력한 값을 바로 볼 수 없기 때문에 잘 못된 값이 입력되면 기존 설정 값으로 초기화한다.
      let pattern = /\s/g;
      if (pattern.test(row[target])) {
        this.$message(msgUtil.getCustomMsgData('변경 비밀번호에 공백이 들어갈 수 없습니다.'));
        row[target] = '********';
        return false;
      }
      pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
      if (pattern.test(row[target])) {
        this.$message(msgUtil.getCustomMsgData('변경 비밀번호에 한글이 들어갈 수 없습니다.'));
        row[target] = '********';
        return false;
      }
      return true;
    },
    /**
     * Host Address Validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validatorForHostAddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback();
      } else if (matcher.ipv4().test(value) || matcher.ipv6().test(value) || matcher.domainName().test(value)) {
        callback();
      } else {
        this.$message(msgUtil.getCustomMsgData('서버 주소를 올바르게 입력해주십시오.'));
        callback(new Error(''));
      }
    },
    /**
     * Email Validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validatorForEmail(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback();
      } else if (matcher.email().test(value)) {
        callback();
      } else {
        this.$message(msgUtil.getCustomMsgData('이메일을 올바르게 입력해주십시오.'));
        callback(new Error(''));
      }
    },
    clearAllValidate() {
      this.$refs.emailSettingDataLeftForm.clearValidate();
      this.$refs.emailSettingDataRightForm.clearValidate();
      this.$refs.smsSettingDataLeftForm.clearValidate();
      this.$refs.smsSettingDataRightForm.clearValidate();
      // this.$refs.alarmClientSettingDataForm.clearValidate();
    },
    onSmsSenderDbTypeChange(val) {
      this.checkChangeFlag('sms');
      OperationSettingsAPI.getDatabaseInfo(val).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.smsSettingData.SMS_SENDER_DB_DRIVERCLASSNAME = data.DbDriverName && data.DbDriverName.basicinfoSubname;
          this.smsSettingData.SMS_SENDER_DB_URL = data.DbAddress && data.DbAddress.basicinfoSubname;
        }
      });
    },
  },
};
</script>

<style scoped>
.alarm-settings .el-row {
  padding-bottom: 15px;
}

.alarm-title {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/AlarmForSetting.vue